import {Component, Input} from '@angular/core';
import {SUPPORT_EMAIL} from '../../domain/constants';

@Component({
    selector: 'af-support-notice',
    standalone: false,
    templateUrl: './support-notice.component.html',
})
export class SupportNoticeComponent {
    @Input() accentText: string;
    @Input() warningText: string;
    readonly SUPPORT_EMAIL = SUPPORT_EMAIL;
}
